// src/redux/archerChat/reducer.js

import {
  ARCHER_SEND_MESSAGE,
  ARCHER_MESSAGE_SUCCESS,
  ARCHER_MESSAGE_FAILURE,
  ARCHER_TEXT_DELTA,
  ARCHER_SET_CONVERSATION,
  ARCHER_SET_DATA,
  ARCHER_TOOL_ACTIVE,
  ARCHER_NEW_CONVERSATION,
  ARCHER_TOGGLE_WIDGET,
} from './constants';

const initialState = {
  open:           false,
  loading:        false,
  toolActive:     null,   // name of tool currently running e.g. 'mysql_query'
  conversationId: null,
  messages:       [],     // { role, text, data, chartType, navigate, sql }
  streamingText:  '',     // in-progress text before TEXT_MESSAGE_END
  pendingData:    null,   // archer.data payload waiting to attach to final message
  error:          null,
};

const ArcherChatReducer = (state = initialState, action) => {
  switch (action.type) {

    case ARCHER_TOGGLE_WIDGET:
      return { ...state, open: !state.open };

    case ARCHER_SEND_MESSAGE:
      return {
        ...state,
        loading:      true,
        toolActive:   null,
        error:        null,
        streamingText: '',
        pendingData:  null,
        messages: [
          ...state.messages,
          { role: 'user', text: action.payload.message },
        ],
      };

    case ARCHER_SET_CONVERSATION:
      return { ...state, conversationId: action.payload };

    // Real-time text streaming — update last message in place
    case ARCHER_TEXT_DELTA:
      return { ...state, streamingText: action.payload };

    case ARCHER_TOOL_ACTIVE:
      return { ...state, toolActive: action.payload };

    // Store data payload — will be merged into final message on SUCCESS
    case ARCHER_SET_DATA:
      return { ...state, pendingData: action.payload };

    case ARCHER_MESSAGE_SUCCESS: {
      const { reply } = action.payload;
      const pd = state.pendingData || {};

      // Build nav message if navigate info present
      const newMessages = [];
      if (pd.navigate) {
        newMessages.push({
          role:   'nav',
          label:  pd.navigate.label,
          url:    pd.navigate.url,
          newTab: pd.navigate.newTab !== false,
        });
      }

      // Assistant message with full text + data
      newMessages.push({
        role:      'assistant',
        text:      reply || state.streamingText,
        data:      pd.data      || null,
        chartType: pd.chartType || null,
        sql:       pd.sql       || null,
      });

      return {
        ...state,
        loading:       false,
        toolActive:    null,
        streamingText: '',
        pendingData:   null,
        messages: [...state.messages, ...newMessages],
      };
    }

    case ARCHER_MESSAGE_FAILURE:
      return {
        ...state,
        loading:    false,
        toolActive: null,
        error:      action.payload,
      };

    case ARCHER_NEW_CONVERSATION:
      return {
        ...state,
        conversationId: null,
        messages:       [],
        streamingText:  '',
        pendingData:    null,
        error:          null,
      };

    default:
      return state;
  }
};

export default ArcherChatReducer;
